// styling
import styles from './styles.module.scss';

// hooks
import { useSidebar } from '@/contexts/SidebarContext';
import { useTranslation } from 'react-i18next';

// utils
import classNames from 'classnames';

const SidebarTrigger = () => {
    const { open, setOpen } = useSidebar();
    const { t } = useTranslation('common');

    return (
        <button className={classNames([styles.burger, open && styles.active])}
                onClick={() => setOpen(!open)}
                aria-label={t('openSidebar')}>
            <span className={styles.burgerLine} />
            <span className={styles.burgerLine} />
            <span className={styles.burgerLine} />
        </button>
    );
};

export default SidebarTrigger;
